import { render, staticRenderFns } from "./preSale.vue?vue&type=template&id=397c7d0f&scoped=true"
import script from "./preSale.vue?vue&type=script&lang=js"
export * from "./preSale.vue?vue&type=script&lang=js"
import style0 from "./preSale.vue?vue&type=style&index=0&id=397c7d0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c7d0f",
  null
  
)

export default component.exports